import { render, staticRenderFns } from "./SplashModal.vue?vue&type=template&id=779be26a&"
import script from "./SplashModal.vue?vue&type=script&lang=js&"
export * from "./SplashModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports